import ResourceLibraryScreen from "../componenets/resourceLibrary/ResourceLibraryScreen";
import guidesConfig from "../componenets/resourceLibrary/guidesConfig";

const GuidesScreen = () => <ResourceLibraryScreen config={guidesConfig}/>;

export default GuidesScreen;
